export default __webpack_public_path__ + "images/D2.243b3cd.png";